import React, { useState } from 'react';
import { Card } from '../ui';

// Compact card for a single school: real logo when available, otherwise a
// color-chipped initial. Mascot shown as the subtitle.
const SchoolCard = ({ school, district }) => {
  const [imgOk, setImgOk] = useState(true);
  const chips = school.colors && school.colors.length
    ? school.colors
    : [district?.colors?.primary || '#1e3a8a', district?.colors?.accent || '#fbbf24'];

  const initial = school.name?.charAt(0)?.toUpperCase() || 'S';
  const showLogo = school.logo && imgOk;

  return (
    <Card hover className="p-4 flex items-center gap-3">
      {showLogo ? (
        <div className="flex-shrink-0 w-11 h-11 rounded-xl bg-white ring-1 ring-ink-100 flex items-center justify-center overflow-hidden">
          <img
            src={school.logo}
            alt={`${school.name} logo`}
            className="w-full h-full object-contain p-0.5"
            loading="lazy"
            onError={() => setImgOk(false)}
          />
        </div>
      ) : (
        <div
          className="flex-shrink-0 w-11 h-11 rounded-xl flex items-center justify-center font-bold text-white"
          style={{ background: `linear-gradient(135deg, ${chips[0]} 0%, ${chips[1] || chips[0]} 100%)` }}
        >
          {initial}
        </div>
      )}

      <div className="min-w-0 flex-grow">
        <p className="font-semibold text-ink-900 text-sm truncate">{school.name}</p>
        {school.mascot && <p className="text-xs text-ink-500 truncate">{school.mascot}</p>}
      </div>

      <div className="flex flex-col gap-1 flex-shrink-0">
        {chips.slice(0, 2).map((c, i) => (
          <span key={i} className="block w-2.5 h-2.5 rounded-full ring-1 ring-ink-200" style={{ backgroundColor: c }} />
        ))}
      </div>
    </Card>
  );
};

export default SchoolCard;
